// removed by extract-text-webpack-plugin
module.exports = {"snackbar":"_2mQxUA44XQRuGZbgdfelDA","accept":"_1JhY3pVWR5AG9HUaaxFsTa","button":"_2S9KF98Cgjik0WX8j5Mz8O","warning":"_3Cso-9cN7TcENSCCL9Jqqf","cancel":"_20fn7lrLQCnABP6jWWsGij","active":"_2PGjZxlVeGd5KoxMGcwro8","label":"_1kFx1grYDMaLZL2ZhMRftI"};


//////////////////
// WEBPACK FOOTER
// ../~/react-toolbox/lib/snackbar/theme.scss
// module id = 1040
// module chunks = 0